import React, { useId } from "react";

import { useAuth } from "../../hooks";
import { useRoleDisplay } from "../../store/companyStore";

const ProfilePage: React.FC = () => {
  const { user, userDisplayName } = useAuth();
  const roleDisplay = useRoleDisplay();
  const mainContentId = useId();
  const profileHeaderId = useId();

  if (!user) {
    return null;
  }

  return (
    <div
      role="main"
      aria-label="Página de perfil do usuário"
      id={mainContentId}
    >
      <div
        id={profileHeaderId}
        className="bsds-display-flex bsds-align-items-center bsds-mb-24"
        role="region"
        aria-label="Informações do perfil"
      >
        <div
          className="w-12 h-12 sm:w-16 sm:h-16 bg-primary-600 rounded-full flex items-center justify-center"
          role="img"
          aria-label={`Avatar do usuário ${userDisplayName}`}
        >
          <span
            className="text-white text-lg sm:text-xl font-bold"
            aria-hidden="true"
          >
            {userDisplayName.charAt(0).toUpperCase()}
          </span>
        </div>
        <div>
          <h6 className="ml-4 text-lg sm:text-xl font-bold">
            {userDisplayName}
          </h6>
          <div className="ml-4 flex space-x-2 mt-1">
            <span
              className="inline-flex items-center py-0.5 text-xs px-2 font-medium bg-red-50 text-red-600"
              role="status"
              aria-label={`Função do usuário: ${roleDisplay || "—"}`}
            >
              {roleDisplay || "—"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
